import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <>
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="bg-gradient-to-br from-primary-500/10 via-accent-100/30 to-primary-100/20 border border-primary-200/40 rounded-lg p-8 md:p-12 text-center">
            <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mx-auto mb-5">
              <i className="ri-book-read-line text-accent-600 text-xl"></i>
            </span>
            <h3 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-3">
              Want to Learn More About Sugargoo Spreadsheet?
            </h3>
            <p className="text-foreground-500 max-w-lg mx-auto text-sm md:text-base mb-6">
              Read our in-depth guide covering everything from what Sugargoo Spreadsheet is, how to use it effectively, shipping tips, and expert shopping strategies for 2026.
            </p>
            <Link
              to="/sugargoo-spreadsheet-guide"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-md text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-right-line"></i>
              Read the Complete Guide
            </Link>
          </div>
        </div>
      </section>

      <section className="relative py-16 md:py-24 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Beautiful%20curated%20product%20display%20with%20colorful%20sneakers%2C%20folded%20hoodies%2C%20leather%20bags%20and%20accessories%20arranged%20in%20a%20harmonious%20composition%20on%20warm%20cream%20surface%2C%20soft%20natural%20window%20lighting%2C%20aspirational%20lifestyle%20shopping%20photography%2C%20sage%20green%20and%20beige%20tones%2C%20elegant%20retail%20catalog%20editorial%20style%2C%20clean%20modern%20aesthetic&width=1600&height=600&seq=cta-bg-sugargoo-v2&orientation=landscape"
          alt="Sugargoo Spreadsheet product collection"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/45"></div>
        <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
            Ready to Explore the Best Sugargoo Spreadsheet Resources?
          </h2>
          <p className="text-white/80 text-sm md:text-base max-w-xl mx-auto mb-8">
            Browse through organized categories, discover trending products, and shop with confidence. Your next great find is just a click away.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto bg-accent-500 hover:bg-accent-600 text-background-50 px-8 py-3.5 rounded-md text-base font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              Start Exploring Now
            </a>
            <Link
              to="/sugargoo-spreadsheet-guide"
              className="w-full sm:w-auto bg-white/15 hover:bg-white/25 text-white border border-white/30 px-8 py-3.5 rounded-md text-base font-semibold transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              Read Our Guide
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}